import React from 'react';

interface AlertProps {
  className?: string;
  children: React.ReactNode;
  variant?: 'default' | 'destructive' | 'success' | 'warning' | 'info';
}

const variantStyles = {
  default: 'bg-gray-50 border border-gray-200 text-gray-900',
  destructive: 'bg-red-50 border border-red-200 text-red-900',
  success: 'bg-green-50 border border-green-200 text-green-900',
  warning: 'bg-yellow-50 border border-yellow-200 text-yellow-900',
  info: 'bg-blue-50 border border-blue-200 text-blue-900',
};

export const Alert: React.FC<AlertProps> = ({
  className = '',
  children,
  variant = 'default',
}) => {
  return (
    <div
      className={`rounded-lg p-4 flex gap-4 ${variantStyles[variant]} ${className}`}
      role="alert"
    >
      {children}
    </div>
  );
};

interface AlertDescriptionProps {
  className?: string;
  children: React.ReactNode;
}

export const AlertDescription: React.FC<AlertDescriptionProps> = ({
  className = '',
  children,
}) => {
  return (
    <div className={`text-sm ${className}`}>
      {children}
    </div>
  );
};
